import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES, ADOBE_TAGS, AdobeService, ADOBE_VARIANT_CONSTANTS } from '@sm360/widget-commons-general';
import { InputDropDown } from '@sm360/widget-commons-forms';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/ModelTrims/modelTrims.scss';
import 'build-and-quote/components/ModelTrims/modelTrimSelection.scss';

const Trims = ({ availableModelTrims, onSelect, selectedTrim, hasAdobeTagging }) => {
    useEffect(() => {
        if (hasAdobeTagging) {
            AdobeService.eventTrigger(ADOBE_TAGS.BUILDER_STEPS('trim'), ADOBE_VARIANT_CONSTANTS.GLOBAL_OVERLAY);
        }
    }, []);
    const options = availableModelTrims.map((modelTrim) => {
        return {
            ...modelTrim.toObject(),
            label: modelTrim.getModelTrimFullDescription(),
            value: modelTrim.trimCode,
        };
    });

    const availableModelTrimsSection = availableModelTrims ? (
        options.map((modelTrim) => {
            const availableModelTrimsSectionClasses = ['style-trim__lists__item'];
            if (modelTrim.selected) {
                availableModelTrimsSectionClasses.push('selected has-price-background');
            }
            if (!modelTrim.enabled) {
                availableModelTrimsSectionClasses.push('disabled');
            }
            return (
                <li key={modelTrim.selectionCode} className={availableModelTrimsSectionClasses.join(' ')}>
                    <button className="style-trim-btn" onClick={() => modelTrim.enabled && onSelect(modelTrim)}>
                        {modelTrim.label}
                    </button>
                </li>
            );
        })
    ) : (
        <li />
    );

    return (
        <div className="bloc-container clearfix">
            <div className="bloc-container-wrapper">
                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <div className="style-trim">
                        <ul className="style-trim__lists">{availableModelTrimsSection}</ul>
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <InputDropDown
                        name="trim"
                        options={options.filter(({ enabled }) => enabled)}
                        placeholder={LocaleService.t('modelTrimSection.label')}
                        value={selectedTrim ? selectedTrim.trimCode : null}
                        isRequired
                        valueChange={(trim) => onSelect(trim)}
                    />
                </MediaQuery>
            </div>
        </div>
    );
};

Trims.propTypes = {
    availableModelTrims: PropTypes.arrayOf(ModelYear.ModelTrimModel).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedTrim: PropTypes.instanceOf(ModelYear.ModelTrimModel).isRequired,
    hasAdobeTagging: PropTypes.bool.isRequired,
};

Trims.displayName = 'Trims';

export default Trims;
